import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { className: "bg-[#690722] text-white" }
const _hoisted_2 = { className: "flex flex-row mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 sm:pt-[8rem] flex-wrap sm:pb-[6rem] pt-[4rem] pb-[2rem]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { className: "w-ful m-auto text-[2.25rem] md:text-[57px] font-bold md:leading-[64px] leading-[40px]" }, " Send and Receive packages from your doorstep to any location in the world through Dellyman ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-[16px] sm:w-[60%] text-center m-auto mt-7 mb-7" }, " Use Dellyman to ship packages to your customers, friends, and family in Lagos, Abuja, London, Ghana, New York, Dubai and 200+ more cities. Say goodbye to stressful shipping forever! ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sm:w-[80%] text-center m-auto" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "bg-yellow-400 !border-2 rounded-full text-red-900 border-none px-10 py-2 cursor-pointer font-bold hover:bg-none hover:border-2 hover:border-white hover:text-white" }, " Ship Now ")
], -1)
const _hoisted_6 = { class: "md:w-[728px] w-[100%] m-auto bg-[#F4F4F4] mt-[5rem] rounded-[50px] md:h-[680px]" }
const _hoisted_7 = { onSubmit: "{methods.handleSubmit(onSubmit)}" }
const _hoisted_8 = { className: "md:3/4 p-8 px-6 sm:px-14 rounded-[50px] text-[#690722] text-center sm:text-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { className: "text-[1.5rem] pt-5 px-6 sm:px-0 sm:text-[36px] font-bold" }, " Get Estimate ", -1)
const _hoisted_10 = { class: "my-[1.7rem] flex items-center" }
const _hoisted_11 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "11",
  viewBox: "0 0 14 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.01105 10.5397C4.73091 10.5397 4.46478 10.4277 4.26868 10.2316L0.304651 6.2676C-0.10155 5.8614 -0.10155 5.18907 0.304651 4.78286C0.710852 4.37666 1.38319 4.37666 1.78939 4.78286L5.01105 8.00446L12.2106 0.804895C12.6168 0.398694 13.2891 0.398694 13.6953 0.804895C14.1015 1.2111 14.1015 1.88343 13.6953 2.28963L5.75342 10.2316C5.55732 10.4277 5.29119 10.5397 5.01105 10.5397Z",
    fill: "white"
  })
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Local ")
const _hoisted_15 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "11",
  viewBox: "0 0 14 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.01105 10.5397C4.73091 10.5397 4.46478 10.4277 4.26868 10.2316L0.304651 6.2676C-0.10155 5.8614 -0.10155 5.18907 0.304651 4.78286C0.710852 4.37666 1.38319 4.37666 1.78939 4.78286L5.01105 8.00446L12.2106 0.804895C12.6168 0.398694 13.2891 0.398694 13.6953 0.804895C14.1015 1.2111 14.1015 1.88343 13.6953 2.28963L5.75342 10.2316C5.55732 10.4277 5.29119 10.5397 5.01105 10.5397Z",
    fill: "white"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Inter-State ")
const _hoisted_19 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "11",
  viewBox: "0 0 14 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.01105 10.5397C4.73091 10.5397 4.46478 10.4277 4.26868 10.2316L0.304651 6.2676C-0.10155 5.8614 -0.10155 5.18907 0.304651 4.78286C0.710852 4.37666 1.38319 4.37666 1.78939 4.78286L5.01105 8.00446L12.2106 0.804895C12.6168 0.398694 13.2891 0.398694 13.6953 0.804895C14.1015 1.2111 14.1015 1.88343 13.6953 2.28963L5.75342 10.2316C5.55732 10.4277 5.29119 10.5397 5.01105 10.5397Z",
    fill: "white"
  })
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" International ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-[#02021E] text-[22px] font-medium" }, "Pickup", -1)
const _hoisted_24 = { className: "text-[16px] pt-1 flex flex-wrap justify-between" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-[#02021E] text-[22px] font-medium" }, " Destination ", -1)
const _hoisted_26 = { className: "text-[16px] pt-1 flex flex-wrap justify-between" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-[#02021E] text-[22px] font-medium" }, "Package", -1)
const _hoisted_28 = { className: "text-[16px] pt-1 flex flex-wrap justify-between" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { className: "pt-3" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "bg-[#690722] !border-2 rounded-full text-white border-none px-10 h-[57px] py-2 cursor-pointer font-bold hover:bg-none hover:border-2 hover:border-white hover:text-white" }, " Get Estimate ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_select = _resolveComponent("custom-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("form", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: _normalizeClass(["bg-[#ffffff] text-black cursor-pointer h-[56px] w-min-[140px] w-[140px] mr-4 flex items-center justify-center rounded-[2rem]", {
                  '!text-white !bg-[#F54748] font-bold': _ctx.activeTab === 'local',
                }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActive('local')))
              }, [
                (_ctx.activeTab === 'local')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
                  : _createCommentVNode("", true),
                _hoisted_14
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["bg-[#ffffff] cursor-pointer h-[56px] mr-4 w-min-[140px] w-[140px] text-black flex items-center justify-center rounded-[2rem]", {
                  'text-white !bg-[#F54748] font-bold':
                    _ctx.activeTab === 'interstate',
                }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActive('interstate')))
              }, [
                (_ctx.activeTab === 'interstate')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_17))
                  : _createCommentVNode("", true),
                _hoisted_18
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["bg-[#ffffff] cursor-pointer h-[56px] w-min-[140px] w-[164px] text-black flex items-center justify-center rounded-[2rem]", {
                  'text-white !bg-[#F54748] font-bold':
                    _ctx.activeTab === 'international',
                }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActive('international')))
              }, [
                (_ctx.activeTab === 'international')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_21))
                  : _createCommentVNode("", true),
                _hoisted_22
              ], 2)
            ]),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_custom_select, { title: "Select State" }),
              _createVNode(_component_custom_select, { title: "Select Zone" })
            ]),
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_custom_select, { title: "Select State" }),
              _createVNode(_component_custom_select, { title: "Select Zone" })
            ]),
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_custom_select, { title: "Type of Carrier" }),
              _createVNode(_component_custom_select, { title: "Package size in Kg" })
            ]),
            _hoisted_29
          ])
        ])
      ])
    ])
  ]))
}